export default __webpack_public_path__ + "static/media/outline_close.0c485648.svg";